<template>
    <div class="doc-section">
        <h1>Visualización de Dispositivos</h1>
        <p>A continuación, se detallan las funciones para localizar dispositivos específicos o gestionar la visibilidad
            global en el mapa.</p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <h2>Ver dispositivo</h2>
        <div v-if="plataforma === 'web'" class="platform-content">
            <p>
                Al hacer clic en el icono de localización, el mapa centrará y mostrará automáticamente el marcador del
                dispositivo seleccionado.
            </p>
            <CarruselAciqui :items="[imagenes[0]]" />

            <h2>Visualización Global</h2>
            <p>Si requiere visualizar la totalidad de sus unidades registradas simultáneamente, siga estos pasos:</p>

            <ul class="ul-contenedor step-list">
                <li>Acceder a la sección de <strong>Monitoreo</strong>.
                    <CarruselAciqui :items="[imagenes[1]]" />
                </li>
                <li>Despliegue el menú lateral derecho mediante el botón <strong>Dispositivos y Ubicaciones</strong>.
                    <CarruselAciqui :items="[imagenes[2]]" />
                </li>
                <li>En la parte superior del listado, localice y de click en el botón <strong>Mostrar
                        dispositivos</strong>.
                    <CarruselAciqui :items="[imagenes[3]]" />
                </li>
                <li>
                    Se mostrará en el mapa todos los dispositivos que tengan posiciones registradas en el sistema y para
                    ocultar los dispositios dar clic en el botón <strong>Ocultar dispositivos</strong>.
                    <CarruselAciqui :items="[imagenes[4]]" />
                </li>
            </ul>

            <div class="info-card">
                <p>
                    <strong>Alternar Visibilidad:</strong>
                    Al activar esta función, todos los dispositivos aparecerán en el mapa. Note que la leyenda del botón
                    cambiará automáticamente a <strong>Ocultar dispositivos</strong>, permitiéndole limpiar el mapa con
                    un
                    solo clic cuando sea necesario.
                </p>
            </div>
        </div>

         <div v-if="plataforma === 'moviles'" class="platform-content">
            <p>
                Al hacer clic en el icono de localización, el mapa centrará y mostrará automáticamente el marcador del
                dispositivo seleccionado.
            </p>
            <CarruselAciqui :items="[imagenesMoviles[0]]" />

            <h2>Visualización Global</h2>
            <p>Si requiere visualizar la totalidad de sus unidades registradas simultáneamente, siga estos pasos:</p>

            <ul class="ul-contenedor step-list">
                <li>Acceder a la sección de <strong>Monitoreo</strong>.
                    <CarruselAciqui :items="[imagenesMoviles[1]]" />
                </li>
                <li>Despliegue el menú lateral derecho mediante el botón <strong>Dispositivos y Ubicaciones</strong>.
                    <CarruselAciqui :items="[imagenesMoviles[2]]" />
                </li>
                <li>En la parte superior del listado, localice y de click en el botón <strong>Mostrar
                        dispositivos</strong>, se mostrará en el mapa todos los dispositivos que tengan posiciones registradas en el sistema.
                    <CarruselAciqui :items="imagenesMoviles.slice(3,5)" />
                </li>
                <li>
                    Ocultar los dispositios dar clic en el botón <strong>Ocultar dispositivos</strong>.
                    <CarruselAciqui :items="[imagenesMoviles[4]]" />
                </li>
            </ul>

            <div class="info-card">
                <p>
                    <strong>Alternar Visibilidad:</strong>
                    Al activar esta función, todos los dispositivos aparecerán en el mapa. Note que la leyenda del botón
                    cambiará automáticamente a <strong>Ocultar dispositivos</strong>, permitiéndole limpiar el mapa con
                    un
                    solo clic cuando sea necesario.
                </p>
            </div>
        </div>


    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'MonitoreoDetalle',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenes: [
            {
                nombre: "",
                url: "img/monitoreo/dispositivo_seleccionado.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/pantalla_principal.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/menu_derecho.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/VerTodos.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/ocultar_todos.png",
                descripcion: ""
            }
        ],

        imagenesMoviles: [
            {
                nombre: "",
                url: "img/monitoreo/moviles/dispositivo_seleccionado.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/moviles/monitoreo.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/moviles/barDispositivos.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/moviles/VerTodos.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/moviles/listadoDispoTodos.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/monitoreo/moviles/ocultar_todos.png",
                descripcion: ""
            },
            
        ]
    }),
    methods: {
    actualizarVista(val) {
      this.plataforma = val;
    }
  }
}
</script>